"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFieldInArray = void 0;
const updateFieldInArray = (arr, fieldName, prop, value) => {
    return arr.map(item => {
        if (item.name === fieldName) {
            return Object.assign(Object.assign({}, item), { [prop]: value });
        }
        return item;
    });
};
exports.updateFieldInArray = updateFieldInArray;
